/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-0b4c3c44.mjs';
import { defineComponent, computed, createVNode } from 'vue';
import props from './props.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-bfb23a5e.mjs';
import '../_chunks/dep-a48de419.mjs';
import '../_chunks/dep-2a7dc5c7.mjs';
import '../_chunks/dep-9311bf66.mjs';
import '../_chunks/dep-4889eb51.mjs';
import '../_chunks/dep-0b4185fe.mjs';
import '../_chunks/dep-3ca5fb38.mjs';
import '../_chunks/dep-7071345f.mjs';
import '../_chunks/dep-d2403b2f.mjs';
import '../_chunks/dep-7922050a.mjs';
import '../_chunks/dep-169ea640.mjs';
import '../_chunks/dep-f6b25712.mjs';
import '../_chunks/dep-59545a4d.mjs';
import '../_chunks/dep-c27b1c14.mjs';
import '../_chunks/dep-7d96367f.mjs';
import '../_chunks/dep-827c4600.mjs';
import '../_chunks/dep-0820e0e2.mjs';
import '../_chunks/dep-caad2e91.mjs';
import '../_chunks/dep-3d4aad09.mjs';
import '../_chunks/dep-8e38f523.mjs';
import '../_chunks/dep-469bf54b.mjs';
import '../_chunks/dep-8ef9fb8e.mjs';
import '../_chunks/dep-e769aafd.mjs';
import '../_chunks/dep-400798c5.mjs';
import '../_chunks/dep-361522ee.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../config-provider/type.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var swiperItemProps = {
  index: {
    type: Number
  },
  currentIndex: {
    type: Number
  },
  isSwitching: {
    type: Boolean,
    "default": false
  },
  getWrapAttribute: {
    type: Function
  },
  swiperItemLength: {
    type: Number,
    "default": 0
  }
};
var CARD_SCALE = 210 / 332;
var itemWidth = 0.415;
var _SwiperItem = defineComponent({
  name: "TSwiperItem",
  props: _objectSpread(_objectSpread({}, props), swiperItemProps),
  setup: function setup(props2, _ref) {
    var slots = _ref.slots;
    var prefix = usePrefixClass();
    var active = computed(function () {
      return props2.index === props2.currentIndex;
    });
    var disposeIndex = computed(function () {
      if (props2.type !== "card") return 0;

      if (props2.currentIndex === 0 && props2.index === props2.swiperItemLength - 1) {
        return -1;
      }

      if (props2.currentIndex === props2.swiperItemLength - 1 && props2.index === 0) {
        return props2.swiperItemLength;
      }

      if (props2.index < props2.currentIndex - 1 && props2.currentIndex - props2.index >= props2.swiperItemLength / 2) {
        return props2.swiperItemLength + 1;
      }

      if (props2.index > props2.currentIndex + 1 && props2.index - props2.currentIndex >= props2.swiperItemLength / 2) {
        return -2;
      }

      return props2.index;
    });
    var translateX = computed(function () {
      if (props2.type !== "card") return 0;
      var wrapWidth = props2.getWrapAttribute("offsetWidth") || 0;
      var translateIndex = !active.value && props2.swiperItemLength > 2 ? disposeIndex.value : props2.index;
      var inStage = Math.abs(translateIndex - props2.currentIndex) <= 1;

      if (inStage) {
        return wrapWidth * ((translateIndex - props2.currentIndex) * (1 - itemWidth * CARD_SCALE) - itemWidth + 1) / 2;
      }

      if (translateIndex < props2.currentIndex) {
        return -itemWidth * (1 + CARD_SCALE) * wrapWidth / 2;
      }

      return (2 + itemWidth * (CARD_SCALE - 1)) * wrapWidth / 2;
    });
    var zIndex = computed(function () {
      if (props2.type !== "card") return 0;
      var translateIndex = !active.value && props2.swiperItemLength > 2 ? disposeIndex.value : props2.index;
      var isActivity = translateIndex === props2.currentIndex;
      var inStage = Math.round(Math.abs(translateIndex - props2.currentIndex)) <= 1;

      if (isActivity) {
        return 2;
      }

      if (inStage) {
        return 1;
      }

      return 0;
    });
    var itemStyle = computed(function () {
      if (props2.animation === "fade") {
        return {
          opacity: active.value ? 1 : 0,
          transition: props2.isSwitching ? "opacity ".concat(props2.duration / 1e3, "s") : ""
        };
      }

      if (props2.type === "card") {
        var translateIndex = !active.value && props2.swiperItemLength > 2 ? disposeIndex.value : props2.index;
        var isActivity = translateIndex === props2.currentIndex;
        return {
          transform: "translateX(".concat(translateX.value, "px) scale(").concat(isActivity ? 1 : CARD_SCALE, ")"),
          transition: "transform ".concat(props2.duration / 1e3, "s ease"),
          zIndex: zIndex.value
        };
      }

      return {};
    });
    return function () {
      var _ref2, _slots$default;

      return createVNode("div", {
        "class": ["".concat(prefix.value, "-swiper__container__item"), (_ref2 = {}, _defineProperty(_ref2, "".concat(prefix.value, "-swiper__card"), props2.type === "card"), _defineProperty(_ref2, "".concat(prefix.value, "-is-active"), props2.type === "card" && active.value), _defineProperty(_ref2, "".concat(prefix.value, "-swiper__fade"), props2.animation === "fade"), _ref2)],
        "style": itemStyle.value
      }, [((_slots$default = slots["default"]) === null || _slots$default === void 0 ? void 0 : _slots$default.call(slots, {})) || []]);
    };
  }
});

export { _SwiperItem as default };
//# sourceMappingURL=swiper-item.mjs.map
